import { render, staticRenderFns } from "./WorkoutMain.vue?vue&type=template&id=529b2a68"
import script from "./WorkoutMain.vue?vue&type=script&lang=js"
export * from "./WorkoutMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports